import get from 'lodash/get';

import { SideItemType } from '~/core/enums';
import { DrawingShape, SideItemInfoModel } from '~/core/models';

const emptyArray = [] satisfies SideItemInfoModel[];

/**
 * return an array of partial SideItemInfoModel records for a given shape
 * @param shape
 */
export const getSideItemsFromShape = (
  shape: DrawingShape
): Partial<SideItemInfoModel>[] =>
  (shape.removedElementsHistory?.edgesAndCorners ?? emptyArray).map((edge) => {
    // Updated type to use SideItemType enum values directly
    type ShapeSide =
      | SideItemType.WALL_SIDE
      | SideItemType.WATERFALL
      | SideItemType.APPLIANCE_SIDE
      | SideItemType.END_CAP
      | SideItemType.END_SPLASH;

    const drawingEdgeSideItem = edge?.drawingEdge.sideItem;
    const depth = drawingEdgeSideItem?.depth;
    const disabled = !!edge?.drawingEdge.customSideType;
    const fieldsBy: Record<ShapeSide, Partial<SideItemInfoModel>> = {
      [SideItemType.WALL_SIDE]: {
        waterfallHeight: undefined,
        backsplash: { checked: !!depth, height: depth },
      },
      [SideItemType.WATERFALL]: {
        waterfallHeight: depth,
        backsplash: undefined,
      },
      [SideItemType.APPLIANCE_SIDE]: {
        waterfallHeight: undefined,
        backsplash: undefined,
      },
      // Laminate-specific side items
      [SideItemType.END_CAP]: {
        waterfallHeight: undefined,
        backsplash: undefined,
      },
      [SideItemType.END_SPLASH]: {
        waterfallHeight: undefined,
        backsplash: undefined,
      },
    };

    return {
      arrowInfo: edge.arrowInfo,
      sideType: edge.sideItemType,
      checked: true,
      disabled,
      ...get(fieldsBy, edge.sideItemType, {}),
    };
  });
